import {
  DeleteLabel,
  GetLabel,
  GetLabels,
  PostLabel,
  PutLabel,
} from "@/server-types";
import { post, get, put, del } from "../request-helpers";
import { useCustomMutation } from "../custom-mutation";
import { useCustomQuery } from "../custom-query";
import { queryClient } from "..";

export const useGetLabels = (query: GetLabels["query"], enabled?: boolean) => {
  return useCustomQuery({
    queryKey: ["labels", query],
    queryFn: () => get<GetLabels>("/label", query),
    enabled: enabled ?? true,
  });
};

export const useGetLabel = (labelId: number | undefined, enabled?: boolean) => {
  return useCustomQuery({
    queryKey: ["label", labelId],
    queryFn: () => get<GetLabel>(`/label/${labelId!}`),
    enabled: (enabled ?? true) && labelId != null,
  });
};

export const usePostLabel = () => {
  return useCustomMutation({
    mutationFn: (body: PostLabel["body"]) => post<PostLabel>("/label", body),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["labels"] });
    },
  });
};

export const usePutLabel = () => {
  return useCustomMutation({
    mutationFn: (props: { labelId: number; body: PutLabel["body"] }) =>
      put<PutLabel>(`/label/${props.labelId}`, props.body),
    onSuccess: (_, props) => {
      queryClient.invalidateQueries({ queryKey: ["labels"] });
      queryClient.invalidateQueries({ queryKey: ["label", props.labelId] });
    },
  });
};

export const useDeleteLabel = () => {
  return useCustomMutation({
    mutationFn: (props: { labelId: number }) =>
      del<DeleteLabel>(`/label/${props.labelId}`),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["labels"] });
    },
  });
};
